import { render, staticRenderFns } from "./HealthRecord.vue?vue&type=template&id=db5139a8&scoped=true&"
import script from "./HealthRecord.vue?vue&type=script&lang=js&"
export * from "./HealthRecord.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecord.vue?vue&type=style&index=0&id=db5139a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5139a8",
  null
  
)

export default component.exports